import React from 'react';
import { _defineHelpUrlandToolTip } from '../helpers/index.js'

const ControlsWhileUntil = function () {
    const name = "controls_whileUntil";
    ControlsWhileUntil.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#loops", "Repeat while the condition is true");

    return (
        <block type={name}></block>
    );
};

export default ControlsWhileUntil;